import ModalWindow from 'components/ModalWindow';
import { useDispatch } from 'react-redux';
import { editUser } from 'store/user';
import icon from "assets/img/icons/icon-warning.svg";

const CombineFail = ({errorText}) => {
  const dispatch = useDispatch();

  const closeHandler = () => {
    dispatch(editUser({ field: "errorText", value: null }));
  };

  return (
    <ModalWindow close={closeHandler}>
      <div className="modal-window__wrapper">
        <header className="modal-window__header">
          <img src={icon} className="modal-window__icon" alt="" />
          <h5 className="modal-window__title">Combine cards fails.</h5>
          <p className="modal-window__info">{errorText}</p>
        </header>
        <footer className="modal-window__footer">
          <button className="modal-window__footer-close" onClick={closeHandler}>
            Done
          </button>
        </footer>
      </div>
    </ModalWindow>
  );
}

export default CombineFail
